import { Card, Typography, Icon } from "@mui/material";
import { useEffect, useState, React } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
// import StatusBar from "../StatusBar";

//unities
import WelcomeScreen from "../../../common/WelcomeScreen";
import { isLight } from "../../../../utils/Color";
import useUpdateDomTitle from "../../../../utils/updateDomTitle";
import useScroller from "../../../../utils/Scroller";
import useLanguage from "../../../../utils/useLanguage";
import ShortenedUrl from "../../../../utils/shortenedurl";
import linkFixer from "../../../../utils/LinkFixer";

const Apps = ({qrData}) => {
  const [welcomeScreen, showWelcomeScreen] = useState(false);
  const data = qrData

  const {t} = useLanguage();
  useUpdateDomTitle(data?.app_title,data?.primaryColor);

  useEffect(()=>{
    showWelcomeScreen(data?.screen ? true : false);
  },[data?.screen])

  const light = isLight(data.primaryColor);

  const openURL = (url) => {
    window.open(linkFixer(url), "_blank");
  };

  const [imageWidth, setImageWidth] = useState(0);
  const [imageHeight, setImageHeight] = useState(0);

  const handleImageLoad = () => {
    const img = new Image();
    img.src = data.companyLogo;
    img.onload = ()=>{
      const { naturalWidth, naturalHeight } = img;
      setImageWidth(naturalWidth);
      setImageHeight(naturalHeight);
    }
  };
  const imageH = Math.floor((imageHeight * 50)  / imageWidth);

  useEffect(() => {
    AOS.init({
      duration: 2000,
    });
    const d = setTimeout(() => {
      showWelcomeScreen(false);
      data.screen = false;
    }, 3000);
    
    return ()=>clearTimeout(d)

  }, [data,data.screen]);

  useScroller(data);

  return welcomeScreen ? (
    <WelcomeScreen screen={data?.screen} />
  ) : (
    <div 
      className="flex flex-col min-h-screen min-w-full items-center "
      // style={{background:data?.primaryColor && data?.SecondaryColor ? "linear-gradient(" +data?.primaryColor +"," +data?.SecondaryColor +")": "#000",}}
    >

    <svg className="fixed top-0 -z-20 w-full h-screen">
      <defs>
        <linearGradient id="grad1" 
          x1="323.5"
          y1="0"
          x2="323.5"
          y2="364"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={data?.primaryColor?data?.primaryColor:"#000"} className="duration-500" />
          <stop offset="1" stopColor={data?.SecondaryColor?data?.SecondaryColor:"#000"} className="duration-500" />
        </linearGradient>
      </defs>
      <rect className="h-full w-full" fill="url(#grad1)" />
    </svg>

      <div
        className="flex flex-col items-center justify-center mt-[50px] xs:mt-[60px] w-full max-w-[450px] px-[16px] break-words text-pretty zoom-block"
      >
        {data?.app_title ? (
          <h1 
            className="text-lg xs:text-2xl font-bold text-center mb-[8px] xs:mb-[14px] duration-500 setpers w-full break-words text-pretty"
            style={{color: light ? "#000000" : "#ffffff", fontFamily: `'${data?.font_title}'`}}
            id="color_palette"
          >
            {data?.app_title}
          </h1>
        ) : (
          <></>
        )}
        {data?.app_company ? (
          <p 
            className="w-full mb-[10px] text-sm xs:text-base duration-500"
            style={{color: light ? "#000000" : "#ffffff", fontFamily: `'${data?.font_text}'`}}
          >
            {data?.app_company}
          </p>
        ) : (
          <></>
        )}
        {data?.companyLogo ? (
          <span 
          style={{
            marginTop: imageH+"px"
          }}
          />
          ):(
            <span className="mt-[10px]" />
            )}
        <div className="flex flex-col items-center justify-center w-full bg-white pb-[26px] mb-[16px]  rounded-[10px] shadow-[1px_6px_30px_rgba(0,31,14,0.05)]" id="app_title">
          {data?.companyLogo ? (
            <>
              {data.companyLogo.includes(".png") || data.companyLogo.includes(".svg") ? (
                <img 
                  onLoad={handleImageLoad}
                  src={data.companyLogo} 
                  className={`w-[100px] mt-[-${imageH+"px"}] mb-[10px] xs:mb-[16px] rounded-[5px] shadow-[1px_6px_30px_rgba(0,31,14,0.05)]`}
                  style={{
                    marginTop: "-"+imageH+"px"
                  }}
                  alt=""
                />
              ):(
                <img 
                  onLoad={handleImageLoad}
                  src={data.companyLogo} 
                  className={`w-[95px] mt-[-${imageH+"px"}] mb-[10px] xs:mb-[20px] border-[1px] border-black rounded-[5px] shadow-[1px_6px_30px_rgba(0,31,14,0.05)]`}
                  style={{
                    marginTop: "-"+imageH+"px"
                  }}
                  alt=""
                />
              )}
            </>
          ) : (
            <span className="pt-[25px]" />
          )}
          
          {data?.app_description ? (
            <p className="w-full text-[#767C83] mb-[8px] xs:mb-[14px] px-[15px] text-[13px] xs:text-lg !leading-[1.35] whitespace-break-spaces text-balance" style={{fontFamily: `'${data?.font_text}'`, overflowWrap: "anywhere"}}>{data?.app_description}</p>
          ) : (
            <span className="pt-[5px]" />
          )}

          <div
            className="flex flex-col items-center px-5 xs:px-10 space-y-3 zoom-block"
            style={{
              height: "auto",
              width:"100%",
            }}
        >
          {data?.apple ? (
            <div 
              className="bg-black flex items-center justify-center xs:justify-start xxs:pl-0 xs:pl-6 xsm:pl-10 rounded-full py-2 space-x-4 hover:opacity-70 active:opacity-[.85] cursor-pointer w-full max-w-full xs:max-w-[240px]"
              onClick={() => {
                if (data.apple === "#"){
                  //do noting :D
                } else {
                  openURL(data.apple);
                }
              }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width={30} height={39} viewBox="0 0 33 41" className="rtl:mr-2">
                <defs>
                  <path id="a" d="M0 .043h32.667v30.435H0z" />
                </defs>
                <g fill="none" fillRule="evenodd">
                  <path
                    fill="#FFF"
                    d="M22.246 6.405C24.862 3.263 24.317 0 24.317 0s-3.66.017-6.293 3.487c-2.341 3.086-1.745 5.725-1.745 5.725s3.174.55 5.967-2.807"
                  />
                  <path
                    fill="#FFF"
                    d="M27.269 11.642c0-5.376 4.333-7.591 4.333-7.591S29.387.043 23.754.043c-3.272 0-5.786 1.862-7.14 1.862-1.578 0-3.933-1.75-6.968-1.75C4.977.154 0 4.334 0 12.302c0 8.1 5.88 18.175 10.535 18.175 1.625 0 4.12-1.637 6.633-1.637 2.467 0 4.287 1.578 6.628 1.578 5.097 0 8.871-10.622 8.871-10.622s-5.398-2.09-5.398-8.155"
                    mask="url(#mask-3)"
                    transform="translate(0 9.593)"
                  />
                </g>
              </svg>
              <div className="flex flex-col text-start text-white">
                <span className="xxs:text-[10px] xs:text-[13px] rtl:mr-2">{t('app.download')}</span>
                <span className="text-sm xs:text-base font-bold block rtl:mr-2">App Store</span>
              </div>
            </div>
          ) : (
            <></>
          )}
          {data?.google ? (
            <div 
              className="bg-black flex items-center justify-center xs:justify-start xxs:pl-0 xs:pl-6 xsm:pl-10 rounded-full py-2 space-x-4 hover:opacity-70 active:opacity-[.85] cursor-pointer w-full max-w-full xs:max-w-[240px]"
              onClick={() => {
                if (data.google === "#"){
                  //do noting :D
                } else {
                  openURL(data.google);
                }
              }}

            >
              <svg xmlns="http://www.w3.org/2000/svg" width={30} height={36} viewBox="0 0 36 42" className="rtl:mr-2">
                <g fill="none" fillRule="evenodd">
                  <path
                    fill="#FFF"
                    d="M21.933 12.365.347.028A.23.23 0 0 0 .124.03C.073.06 0 .12 0 .229l.016 2.836 15.61 15.61 6.307-6.31ZM14.679 19.63.024 4.985l.077 16.818.055 12.348 14.523-14.52ZM35.495 20.116l-12.346-7.054-6.574 6.569 7.523 7.525L35.5 20.514a.23.23 0 0 0 .117-.195.237.237 0 0 0-.122-.203M.156 36.056l.025 4.666c0 .084.038.155.102.188.084.051.17.053.24.01l22.376-13.05-7.273-7.273-15.47 15.46Z"
                  />
                </g>
              </svg>
              <div className="flex flex-col text-start text-white">
                <span className="xxs:text-[10px] xs:text-[13px] rtl:mr-2">{t('app.get')}</span>
                <span className="text-sm xs:text-base font-bold rtl:mr-2">Google Play</span>
              </div>
            </div>
          ) : (
            <></>
          )}
          {data?.amazon ? (
            <div 
              className="bg-black flex items-center justify-center xs:justify-start xxs:pl-0 xs:pl-6 xsm:pl-10 rounded-full py-2 space-x-4 hover:opacity-70 active:opacity-[.85] cursor-pointer w-full max-w-full xs:max-w-[240px]"
              onClick={() => {
                if (data.amazon === "#"){
                  //do noting :D
                } else {
                  openURL(data.amazon);
                }
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={30}
                height={34}
                viewBox="0 0 40 42"
                className="rtl:mr-2"    
              >
                <defs>
                  <path id="a" d="M0 .232h35.248v7.946H0z" />
                  <path id="c" d="M.738.583h7.246v7.135H.738z" />
                  <path id="e" d="M.33.72h25.724v30.749H.33z" />
                </defs>
                <g fill="none" fillRule="evenodd">
                  <g transform="translate(0 33.104)">
                    <mask id="b" fill="#fff">
                      <use xlinkHref="#a" />
                    </mask>
                    <path
                      fill="#FFF"
                      d="M34.937 3.393C30.705 6.513 24.569 8.18 19.289 8.18 11.88 8.18 5.215 5.44.17.883-.226.525.13.036.606.314 6.05 3.484 12.78 5.39 19.732 5.39c4.688 0 9.846-.972 14.59-2.983.715-.307 1.314.468.615.987"
                      mask="url(#b)"
                    />
                  </g>
                  <g transform="translate(30.667 31.992)">
                    <mask id="d" fill="#fff">
                      <use xlinkHref="#c" />
                    </mask>
                    <path
                      fill="#FFF"
                      d="M6.03 2.492c-.54-.691-3.578-.327-4.942-.166-.415.051-.476-.309-.102-.568C3.405.055 7.373.545 7.837 1.116c.462.572-.122 4.553-2.394 6.45-.35.292-.683.14-.527-.25.51-1.275 1.656-4.13 1.114-4.824"
                      mask="url(#d)"
                    />
                  </g>
                  <g transform="translate(6.133 .392)">
                    <mask id="f" fill="#fff">
                      <use xlinkHref="#e" />
                    </mask>
                    <path
                      fill="#FFF"
                      d="M21.61 31.013c-.355.317-.87.341-1.27.129-1.788-1.482-2.105-2.171-3.088-3.586-2.952 3.01-5.042 3.913-8.87 3.913-4.525 0-8.052-2.795-8.052-8.386 0-4.367 2.37-7.342 5.735-8.796 2.923-1.286 7.002-1.512 10.12-1.868v-.697c0-1.278.098-2.791-.652-3.897-.657-.992-1.914-1.4-3.018-1.4-2.053 0-3.884 1.052-4.33 3.232-.09.484-.446.96-.93.983l-5.222-.56c-.44-.098-.924-.454-.803-1.129C2.434 2.626 8.148.718 13.263.718c2.62 0 6.04.698 8.107 2.68 2.618 2.444 2.367 5.707 2.367 9.256v8.384c0 2.521 1.045 3.627 2.028 4.989.35.484.425 1.067-.014 1.429-1.098.916-3.05 2.619-4.126 3.573l-.014-.016m-5.426-13.115v-1.165c-3.89 0-8 .832-8 5.42 0 2.322 1.204 3.896 3.269 3.896 1.513 0 2.868-.932 3.725-2.445 1.059-1.863 1.006-3.61 1.006-5.706"
                      mask="url(#f)"
                    />
                  </g>
                </g>
              </svg>
              <div className="flex flex-col text-start text-white">
                <span className="xxs:text-[10px] xs:text-[13px] rtl:mr-2">{t('app.available')}</span>
                <span className="text-sm xs:text-base font-bold rtl:mr-2">Amazon.com</span>
              </div>
            </div>
          ) : (
            <></>
          )}
          
        </div>
        </div>
        {data?.app_website ? (
          <button 
            onClick={() => {
              if (data.app_website === "www.nourish.com" || data.app_website === "www.mindfulcomfort.com" || data.app_website === "www.greenplate.com"){
                //do noting :D
              } else {
                openURL(data.app_website);
              }
            }}
            className="flex flex-row justify-between items-center bg-white w-full mb-[30px] p-[10px] rounded-[4px] cursor-pointer shadow-[1px_6px_30px_rgba(0,31,14,0.05)]"
            id="app_website"
          >
            <div className="space-x-[5px] xss:space-x-[15px] w-full mr-[5px] flex flex-row">
              <div className="w-[45px] h-[45px] min-w-[30px] rounded-[4px] bg-[#F9F9F9] flex justify-center items-center mr-[5px] rtl:ml-2">
                <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12.0003 21.5781C6.31741 21.5781 1.69824 17.0594 1.69824 11.5C1.69824 5.94063 6.31741 1.42188 12.0003 1.42188C17.6832 1.42188 22.3024 5.94063 22.3024 11.5C22.3024 17.0594 17.6832 21.5781 12.0003 21.5781ZM12.0003 2.82812C7.11283 2.82812 3.13574 6.71875 3.13574 11.5C3.13574 16.2812 7.11283 20.1719 12.0003 20.1719C16.8878 20.1719 20.8649 16.2812 20.8649 11.5C20.8649 6.71875 16.8878 2.82812 12.0003 2.82812Z" fill="#767C83"/>
                  <path d="M9.12547 20.6406H8.16714C7.77422 20.6406 7.44839 20.3219 7.44839 19.9375C7.44839 19.5531 7.75505 19.2437 8.14797 19.2344C6.64339 14.2094 6.64339 8.79063 8.14797 3.76562C7.75505 3.75625 7.44839 3.44687 7.44839 3.0625C7.44839 2.67812 7.77422 2.35938 8.16714 2.35938H9.12547C9.35547 2.35938 9.57589 2.47187 9.71005 2.65C9.84422 2.8375 9.88255 3.07187 9.80589 3.2875C8.00422 8.58437 8.00422 14.4156 9.80589 19.7219C9.88255 19.9375 9.84422 20.1719 9.71005 20.3594C9.57589 20.5281 9.35547 20.6406 9.12547 20.6406Z" fill="#767C83"/>
                  <path d="M14.8753 20.6405C14.7986 20.6405 14.722 20.6311 14.6453 20.603C14.2715 20.4811 14.0607 20.078 14.1949 19.7124C15.9965 14.4155 15.9965 8.58427 14.1949 3.27802C14.0703 2.91239 14.2715 2.50927 14.6453 2.38739C15.0286 2.26552 15.4311 2.46239 15.5557 2.82802C17.4628 8.41552 17.4628 14.5655 15.5557 20.1436C15.4599 20.453 15.1724 20.6405 14.8753 20.6405Z" fill="#767C83"/>
                  <path d="M12 16.375C9.32625 16.375 6.66208 16.0094 4.09375 15.2687C4.08417 15.6437 3.76792 15.9531 3.375 15.9531C2.98208 15.9531 2.65625 15.6344 2.65625 15.25V14.3125C2.65625 14.0875 2.77125 13.8719 2.95333 13.7406C3.145 13.6094 3.38458 13.5719 3.605 13.6469C9.01958 15.4094 14.99 15.4094 20.4046 13.6469C20.625 13.5719 20.8646 13.6094 21.0562 13.7406C21.2479 13.8719 21.3533 14.0875 21.3533 14.3125V15.25C21.3533 15.6344 21.0275 15.9531 20.6346 15.9531C20.2417 15.9531 19.9254 15.6531 19.9158 15.2687C17.3379 16.0094 14.6737 16.375 12 16.375Z" fill="#767C83"/>
                  <path d="M20.6246 9.39053C20.548 9.39053 20.4713 9.38115 20.3946 9.35303C14.98 7.59053 9.00963 7.59053 3.59505 9.35303C3.21171 9.4749 2.80921 9.27803 2.68463 8.9124C2.56963 8.5374 2.77088 8.14365 3.14463 8.02178C8.8563 6.15615 15.143 6.15615 20.845 8.02178C21.2188 8.14365 21.4296 8.54678 21.2955 8.9124C21.2092 9.20303 20.9217 9.39053 20.6246 9.39053Z" fill="#767C83"/>
                </svg>
              </div>
              <div className="flex items-center text-left truncate">
                <p className="text-sm xs:text-base sm:text-xl text-[#0079ff] truncate" style={{fontFamily: `'${data?.font_text}'`}}><ShortenedUrl url={data.app_website} /></p>
              </div>
            </div>
            <svg className="hidden xs:flex mr-[5px] rtl:rotate-180" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4 11.7256C4 11.3459 4.28215 11.0321 4.64823 10.9824L4.75 10.9756H19.75C20.1642 10.9756 20.5 11.3114 20.5 11.7256C20.5 12.1053 20.2178 12.4191 19.8518 12.4687L19.75 12.4756L4.75 12.4756C4.33579 12.4756 4 12.1398 4 11.7256Z" fill="#767C83"/>
              <path d="M13.171 6.23271C12.8775 5.94045 12.8765 5.46558 13.1687 5.17206C13.4344 4.90522 13.851 4.88012 14.1451 5.09734L14.2294 5.16977L20.2794 11.1938C20.547 11.4603 20.5714 11.8784 20.3524 12.1724L20.2794 12.2567L14.2294 18.2817C13.9359 18.574 13.4611 18.573 13.1688 18.2795C12.9031 18.0127 12.8797 17.5959 13.0982 17.3028L13.171 17.2188L18.687 11.7249L13.171 6.23271Z" fill="#767C83"/>
            </svg>
          </button>
        ) : (
          <></>
        )}
      </div>
    </div>
  
  );
};

export default Apps;
